import EventSession from "../../Events/Event/EventSession";

const FeedSessionItem = (props: any) => {
    const { item } = props;
    return item && item.sessionContentItem && item.sessionContentItem.session ? (
        <EventSession id={item._id} isFeed={true} session={item.sessionContentItem.session} communities={[]}></EventSession>
    ) : null
}

export default FeedSessionItem;